import { ExtendedSmartSearchEntityType } from '../../SmartSearch.types.js'

export const MAX_HISTORY_ITEMS = 3
export const MAX_DAYS_TO_KEEP = 30
export const STORAGE_KEY = 'bettermode:search-history'

export const EXCLUDED_SEARCH_HISTORY_ENTITY_TYPES: ExtendedSmartSearchEntityType[] =
  [
    ExtendedSmartSearchEntityType.MEMBERS,
    ExtendedSmartSearchEntityType.HISTORY,
    ExtendedSmartSearchEntityType.SPACES,
  ]
